// @ts-nocheck
import 'datatables.net-bs5';
import 'datatables.net-buttons-bs5';
import * as moment from 'moment';
import { i18n } from '@vendor/libs/lang/lang';
const DTHelpers = {
    getColNumberByElement: (element) => {
        return $(element).index();
    },
    getColNumberByName: (table, name) => {
        table = $(table);
        const element = table.find(`th[data-dt-name="${name}"]`);
        if (!element.length) {
            return null;
        }
        return DTHelpers.getColNumberByElement(element);
    },
};
$.fn.dataTable.Api.register('column().title()', function () {
    //@ts-ignore
    var colheader = this.header();
    return $(colheader).text().trim();
});
var defaults = {
    language: {
        search: '',
        searchPlaceholder: 'Search',
        info: 'Showing _START_ to _END_ of _TOTAL_ records',
        infoEmpty: 'Showing no records',
        lengthMenu: '_MENU_',
        paginate: {
            first: '<i class="first"></i>',
            last: '<i class="last"></i>',
            next: '<i class="next"></i>',
            previous: '<i class="previous"></i>',
        },
    },
};
function naturalSort(a, b, html = false) {
    var re = /(^-?[0-9]+(\.?[0-9]*)[df]?e?[0-9]?%?$|^0x[0-9a-f]+$|[0-9]+)/gi, sre = /(^[ ]*|[ ]*$)/g, dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, hre = /^0x[0-9a-f]+$/i, ore = /^0/, htmre = /(<([^>]+)>)/gi, 
    // convert all to strings and trim()
    x = a.toString().replace(sre, '') || '', y = b.toString().replace(sre, '') || '';
    // remove html from strings if desired
    if (!html) {
        x = x.replace(htmre, '');
        y = y.replace(htmre, '');
    }
    // chunk/tokenize
    var xN = x
        .replace(re, '\0$1\0')
        .replace(/\0$/, '')
        .replace(/^\0/, '')
        .split('\0'), yN = y
        .replace(re, '\0$1\0')
        .replace(/\0$/, '')
        .replace(/^\0/, '')
        .split('\0'), 
    // numeric, hex or date detection
    xD = parseInt(x.match(hre), 10) ||
        (xN.length !== 1 && x.match(dre) && Date.parse(x)), yD = parseInt(y.match(hre), 10) ||
        (xD && y.match(dre) && Date.parse(y)) ||
        null;
    // first try and sort Hex codes or Dates
    if (yD) {
        if (xD < yD) {
            return -1;
        }
        else if (xD > yD) {
            return 1;
        }
    }
    // natural sorting through split numeric strings and default strings
    for (var cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++) {
        // find floats not starting with '0', string or 0 if not defined (Clint Priest)
        var oFxNcL = (!(xN[cLoc] || '').match(ore) && parseFloat(xN[cLoc])) || xN[cLoc] || 0;
        var oFyNcL = (!(yN[cLoc] || '').match(ore) && parseFloat(yN[cLoc])) || yN[cLoc] || 0;
        // handle numeric vs string comparison - number < string - (Kyle Adams)
        if (isNaN(oFxNcL) !== isNaN(oFyNcL)) {
            return isNaN(oFxNcL) ? 1 : -1;
        }
        // rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
        else if (typeof oFxNcL !== typeof oFyNcL) {
            oFxNcL += '';
            oFyNcL += '';
        }
        if (oFxNcL < oFyNcL) {
            return -1;
        }
        if (oFxNcL > oFyNcL) {
            return 1;
        }
    }
    return 0;
}
$.extend(true, $.fn.dataTable.defaults, defaults);
(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['jquery', 'datatables.net'], function ($) {
            return factory($, window, document);
        });
    }
    else if (typeof exports === 'object') {
        CommonJS;
        module.exports = function (root, $) {
            if (!root) {
                root = window;
            }
            if (!$ || !$.fn.dataTable) {
                // Require DataTables, which attaches to jQuery, including
                // jQuery if needed and have a $ property so we can access the
                // jQuery object that is used
                $ = require('datatables.net')(root, $).$;
            }
            return factory($, root, root.document);
        };
    }
    else {
        // Browser
        factory($, window, document);
    }
})(function ($, window, document, undefined) {
    'use strict';
    var DataTable = $.fn.dataTable;
    const dt_polish = {
        ...require('./dt.polish.json'),
        search: '',
        searchPlaceholder: 'Szukaj',
        lengthMenu: '_MENU_',
        paginate: {
            first: '<i class="first"></i>',
            last: '<i class="last"></i>',
            next: '<i class="bx bx-chevron-right align-middle"></i>',
            previous: '<i class="bx bx-chevron-left align-middle"></i>',
        },
    };
    let language = undefined;
    if (window.App && window.App.locale === 'pl') {
        language = dt_polish;
    }
    /* Set the defaults for DataTables initialisation */
    $.extend(true, DataTable.defaults, {
        dom: "<'row'" +
            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'<'tables-elements'f>>" +
            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'<'tables-elements table-buttons-container'>>" +
            '>' +
            "<'table-responsive'tr>" +
            "<'row'" +
            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'<'tables-elements table-footer-addons'li>>" +
            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'<'tables-elements'p>>" +
            '>',
        renderer: 'bootstrap',
        language,
    });
    /* Default class modification */
    $.extend(DataTable.ext.classes, {
        sWrapper: 'dataTables_wrapper dt-bootstrap5',
        sFilterInput: 'form-control form-control-solid',
        sLengthSelect: 'form-select form-select-solid',
        sProcessing: 'dataTables_processing',
        sPageButton: 'paginate_button page-item',
    });
    /* Bootstrap paging button renderer */
    DataTable.ext.renderer.pageButton.bootstrap = function (settings, host, idx, buttons, page, pages) {
        var api = new DataTable.Api(settings);
        var classes = settings.oClasses;
        var lang = settings.oLanguage.oPaginate;
        var aria = settings.oLanguage.oAria.paginate || {};
        var btnDisplay, btnClass, counter = 0;
        var attach = function (container, buttons) {
            var i, ien, node, button;
            var clickHandler = function (e) {
                e.preventDefault();
                if (!$(e.currentTarget).hasClass('disabled') &&
                    api.page() != e.data.action) {
                    api.page(e.data.action).draw('page');
                }
            };
            for (i = 0, ien = buttons.length; i < ien; i++) {
                button = buttons[i];
                if (Array.isArray(button)) {
                    attach(container, button);
                }
                else {
                    btnDisplay = '';
                    btnClass = '';
                    switch (button) {
                        case 'ellipsis':
                            btnDisplay = '&#x2026;';
                            btnClass = 'disabled';
                            break;
                        case 'first':
                            btnDisplay = lang.sFirst;
                            btnClass = button + (page > 0 ? '' : ' disabled');
                            break;
                        case 'previous':
                            btnDisplay = lang.sPrevious;
                            btnClass = button + (page > 0 ? '' : ' disabled');
                            break;
                        case 'next':
                            btnDisplay = lang.sNext;
                            btnClass = button + (page < pages - 1 ? '' : ' disabled');
                            break;
                        case 'last':
                            btnDisplay = lang.sLast;
                            btnClass = button + (page < pages - 1 ? '' : ' disabled');
                            break;
                        default:
                            btnDisplay = button + 1;
                            btnClass = page === button ? 'active text-black' : '';
                            break;
                    }
                    if (btnDisplay) {
                        node = $('<li>', {
                            class: classes.sPageButton + ' ' + btnClass,
                            id: idx === 0 && typeof button === 'string'
                                ? settings.sTableId + '_' + button
                                : null,
                        })
                            .append($('<a>', {
                            href: '#',
                            'aria-controls': settings.sTableId,
                            'aria-label': aria[button],
                            'data-dt-idx': counter,
                            tabindex: settings.iTabIndex,
                            class: 'page-link',
                        }).html(btnDisplay))
                            .appendTo(container);
                        settings.oApi._fnBindAction(node, { action: button }, clickHandler);
                        counter++;
                    }
                }
            }
        };
        // IE9 throws an 'unknown error' if document.activeElement is used
        // inside an iframe or frame.
        var activeEl;
        try {
            // Because this approach is destroying and recreating the paging
            // elements, focus is lost on the select button which is bad for
            // accessibility. So we want to restore focus once the draw has
            // completed
            activeEl = $(host).find(document.activeElement).data('dt-idx');
        }
        catch (e) { }
        attach($(host).empty().html('<ul class="pagination"/>').children('ul'), buttons);
        if (activeEl !== undefined) {
            $(host)
                .find('[data-dt-idx=' + activeEl + ']')
                .trigger('focus');
        }
    };
    $.extend($.fn.dataTableExt.oSort, {
        'natural-asc': function (a, b) {
            return naturalSort(a, b, true);
        },
        'natural-desc': function (a, b) {
            return naturalSort(a, b, true) * -1;
        },
        'natural-nohtml-asc': function (a, b) {
            return naturalSort(a, b, false);
        },
        'natural-nohtml-desc': function (a, b) {
            return naturalSort(a, b, false) * -1;
        },
        'natural-ci-asc': function (a, b) {
            a = a.toString().toLowerCase();
            b = b.toString().toLowerCase();
            return naturalSort(a, b, true);
        },
        'natural-ci-desc': function (a, b) {
            a = a.toString().toLowerCase();
            b = b.toString().toLowerCase();
            return naturalSort(a, b, true) * -1;
        },
    });
    $.fn.dataTable.moment = function (format, locale) {
        var types = $.fn.dataTable.ext.type;
        // Add type detection
        types.detect.unshift(function (d) {
            return moment(d, format, locale, true).isValid()
                ? 'moment-' + format
                : null;
        });
        // Add sorting method - use an integer for the sorting
        types.order['moment-' + format + '-pre'] = function (d) {
            return moment(d, format, locale, true).unix();
        };
    };
    $.fn.dataTable.moment('DD/MM/YYYY HH:mm');
    $.fn.dataTable.moment('DD/MM/YYYY HH:mm:ss');
    $.fn.dataTable.moment('DD/MM/YYYY');
    $.fn.dataTable.moment('YYYY-MM');
    return DataTable;
});
const initDataTable = (element) => {
    let isSmall = $(element).hasClass('dt-sm');
    let isExtraSmall = $(element).hasClass('dt-xs');
    let columnDefs = [];
    $(element)
        .find('th')
        .each(function (i) {
        let dataType = $(this).data('sort-type');
        if (dataType) {
            columnDefs.push({
                targets: i,
                type: dataType,
            });
        }
    });
    return $(element).DataTable({
        retrieve: true,
        // info: false,
        // filter: (!isSmall && !isExtraSmall),
        lengthChange: !isSmall && !isExtraSmall,
        // paginate: !isExtraSmall,
        filter: !isExtraSmall,
        columnDefs,
        info: !isSmall && !isExtraSmall,
        initComplete: () => {
            let container = $(element).closest('.table-container');
            const buttons = container.find('.table-buttons');
            buttons
                .children()
                .clone()
                .appendTo(container.find('.table-buttons-container'));
        },
        drawCallback: function () {
            const table = $(this).DataTable();
            // hiding columns dynamically
            const hideIfEmptyColumns = $(element).find('th[data-dt-hide_if_empty]');
            for (const column of hideIfEmptyColumns) {
                const index = DTHelpers.getColNumberByElement(column);
                const data = this.DataTable().column(index).data().toArray();
                if (data.length == 0 ||
                    data.filter((el) => el.replace(/<[^>]*>?/gm, '').trim() !== '').length == 0) {
                    table.column(index).visible(false);
                }
                else {
                    table.column(index).visible(true);
                }
            }
            // summary columns
            const summaryColumns = $(element).find('tfoot th[data-dt-summary]');
            for (const column of summaryColumns) {
                const index = $(column).index();
                let summary = 0;
                table.$('td:eq(' + index + ')', { page: 'current' }).each(function () {
                    const cell = $(this);
                    const value = cell.text().replace(/[^0-9.]/g, '');
                    const parsed = parseFloat(value);
                    if (!isNaN(parsed)) {
                        summary += parsed;
                    }
                });
                const suffix = $(column).attr('data-dt-summary_suffix');
                $(column).text(summary + (suffix ? ' ' + suffix : ''));
            }
        },
    });
};
$('.dt').each(function () {
    initDataTable(this);
});
const handleCheckbox = (table, info = true) => {
    const checkAllInput = $(table.table().header()).find('[data-app-check="all"]');
    const sync = (check = true) => {
        if (check) {
            const checkedInputs = $(table.table().body()).find('[type="checkbox"]:checked');
            const inputs = $(table.table().body()).find('[type="checkbox"]');
            if (checkedInputs.length) {
                checkAllInput.prop('checked', true);
                checkAllInput.prop('indeterminate', checkedInputs.length != inputs.length);
            }
            else {
                checkAllInput.prop('checked', false);
                checkAllInput.prop('indeterminate', false);
            }
        }
        if (info) {
            $(table.table().container())
                .find('[data-app-check="counter"]')
                .text(i18n.trans('tables.checkbox_handler.counter', {
                amount: table.$('[type="checkbox"]:checked').length,
            }));
        }
    };
    checkAllInput.on('click', function () {
        const checked = $(this).is(':checked');
        $(table.table().body())
            .find('[type="checkbox"]')
            .prop('checked', checked)
            .trigger('change');
        sync(false);
    });
    // add counter
    if (info) {
        $(table.table().container())
            .find('.table-footer-addons')
            .append('<span data-app-check="counter"></span>');
    }
    // sync on checkbox change
    $(table.table().body()).on('change', '[type="checkbox"]', function () {
        sync();
    });
    // sync on draw
    table.on('draw.dt', function () {
        sync();
    });
};
window.initDataTable = initDataTable;
window.handleCheckbox = handleCheckbox;
window.naturalSort = naturalSort;
window.DTHelpers = DTHelpers;
